// extracted by mini-css-extract-plugin
export default {"fontBlue":"UnverifiedIdentity_fontBlue__nC38q"};